<mat-card-content [ngClass]="getMatCardClass()">
  <ng-container *ngIf="businessProfileCardData$ | async as data; else loadingCard">
    <div class="business-profile-overlay" [ngClass]="getOverlayClass()">
      <div class="business-info">
        <div class="business-info-icon">
          <mat-icon>business</mat-icon>
        </div>
        <div>
          <div class="business-profile-name">{{ truncateString(data.listingProfile.napData.companyName) }}</div>
          <div class="business-profile-category" *ngIf="isLoaded && getBusinessCategory(data.listingProfile)">
            {{ businessPrimaryCategory }}
          </div>
          <div class="business-profile-field" *ngIf="data.listingProfile.napData.serviceAreaBusiness">
            (Service area business)
          </div>
          <div class="business-profile-field" *ngIf="isLoaded && validateAddressDisplay(data.listingProfile)">
            {{ truncateString(data.listingProfile.napData.address) }}
          </div>
          <div class="business-profile-field">
            {{ data.listingProfile.napData.city }} {{ data.listingProfile.napData.state }}
            {{ data.listingProfile.napData.zip }}
          </div>
          <div class="business-profile-field">{{ data.listingProfile.napData.country }}</div>
          <div class="business-profile-field" *ngIf="data.listingProfile?.napData?.workNumber?.length > 0">
            {{ data.listingProfile.napData.workNumber[0] }}
          </div>
        </div>
      </div>
    </div>
    <google-map [options]="data.mapOptions" width="100%" [height]="mapPixelSize">
      <map-marker [options]="data.markerOptions"></map-marker>
    </google-map>
  </ng-container>
</mat-card-content>

<ng-template #loadingCard>
  <ng-container>
    <div class="loading">
      <glxy-loading-spinner></glxy-loading-spinner>
    </div>
  </ng-container>
</ng-template>
